import { buryingPoint } from "@/utils/buryingPoint"
import { env } from "@/config"
import store from "@/store"

const publicOption = () => {
  return {
    userUuid: store.state.userInfo.userInfo.userUuid ? store.state.userInfo.userInfo.userUuid : ""
  }
}

export const buryingPoint_home = params => {
  const options = {
    origin: 1,
    action: 1,
    activityId: store.state.activityInfo.activityId || ""
  }
  buryingPoint(Object.assign(options, params, publicOption()), env)
}

export const buryingPoint_detail = params => {
  const options = {
    origin: 1,
    action: 2,
    activityId: store.state.activityInfo.activityId || ""
  }
  buryingPoint(Object.assign(options, params, publicOption()), env)
}

export const buryingPoint_myWork = params => {
  const options = {
    origin: 1,
    action: 3,
    activityId: store.state.activityInfo.activityId || ""
  }
  buryingPoint(Object.assign(options, params, publicOption()), env)
}

export const buryingPoint_contribute = params => {
  const options = {
    origin: 1,
    action: 4,
    activityId: store.state.activityInfo.activityId || ""
  }
  buryingPoint(Object.assign(options, params, publicOption()), env)
}

export const buryingPoint_collection = params => {
  const options = {
    origin: 1,
    action: 5,
    activityId: store.state.activityInfo.activityId || ""
  }
  buryingPoint(Object.assign(options, params, publicOption()), env)
}

export const buryingPoint_shareWork = params => {
  const options = {
    origin: 1,
    action: 21,
    activityId: store.state.activityInfo.activityId || ""
  }
  buryingPoint(Object.assign(options, params, publicOption()), env)
}

export const buryingPoint_shareCollection = params => {
  const options = {
    origin: 1,
    action: 20,
    activityId: store.state.activityInfo.activityId || ""
  }
  buryingPoint(Object.assign(options, params, publicOption()), env)
}

export const buryingPoint_downloadApp = (params = {}) => {
  const options = {
    origin: "share",
    dataType: 1000012,
    clickPosition: 17,
    activityId: store.state.activityInfo.activityId || "",
    subActivityId: window.categoryId || "",
    activityName: document.title
  }
  buryingPoint(Object.assign(options, params, publicOption()), env)
}

export const buryingPoint_advExposure = (params = {}) => {
  const options = {
    origin: "1",
    dataType: 1000099,
    clickPosition: "",
    action: 23,
    optionId: "",
    activityId: store.state.activityInfo.activityId || "",
    subActivityId: window.categoryId || "",
    activityName: document.title
  }
  buryingPoint(Object.assign(options, params, publicOption()), env)
}

export class AdvExposure {
  constructor(target, buryingPointOpitons) {
    this.target = target
    this.intersectionObserver = null
    this.buryingPointOptions = buryingPointOpitons
  }
  initIntersectionObserver() {
    if (this.intersectionObserver) return
    this.intersectionObserver = new IntersectionObserver(entries => {
      if (entries[0].intersectionRatio > 0) {
        buryingPoint_advExposure(this.buryingPointOptions)
      }
    })
  }
  init() {
    this.initIntersectionObserver()
  }
  observe() {
    this.initIntersectionObserver()
    this.target && this.intersectionObserver.observe(this.target)
  }
  unobserve() {
    this.intersectionObserver && this.intersectionObserver.unobserve(this.target)
  }
}

export const buryingPoint_click_adv = (params = {}) => {
  const options = {
    origin: "1",
    dataType: 1000099,
    clickPosition: "",
    action: 24,
    optionId: "",
    activityId: store.state.activityInfo.activityId || "",
    subActivityId: window.categoryId || "",
    activityName: document.title
  }
  buryingPoint(Object.assign(options, params, publicOption()), env)
}

export const buryingPoint_praise = (params = {}) => {
  const options = {
    origin: "1",
    dataType: 1000099,
    clickPosition: "",
    action: 32,
    optionId: "",
    activityId: store.state.activityInfo.activityId || "",
    subActivityId: window.categoryId || "",
    activityName: document.title
  }
  buryingPoint(Object.assign(options, params, publicOption()), env)
}
